






























































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import Loading from "@/components/loader/loading.vue";
import StartSurvey from "@/views/survey/overview/StartSurvey.vue";

@Component({
  components: {
    Loading,
    StartSurvey,
  },
})
export default class OverviewDetails extends Vue {
  loading = false;
  title = this.$route.query.title;
  dispatchType = this.$route.query.dispatchType || "admission";
  headers = [
    {
      text: "Question",
      value: "question",
      width: "25%",
    },
    {
      text: "Resident",
      align: "center",
      sortable: false,
      value: "resident",
    },
    {
      text: this.dispatchType === "satisfaction" ? "Met" : "Rating",
      align: "center",
      sortable: false,
      value: "rating",
    },
    {
      text: "Reported",
      sortable: false,
      value: "reported",
      align: "center",
    },
    {
      text: "Comment",
      sortable: false,
      value: "comment",
      width: "20%",
    },
  ];

  async created() {
    const dispatchType = this.$route.query.dispatchType;
    this.dispatchType = dispatchType ? dispatchType.toString() : "admission";
    const beginAt = this.$route.query.beginAt;
    const endAt = this.$route.query.endAt;
    const overviewId = this.$route.query.overviewId;
    const payload = {
      beginAt,
      endAt,
      dispatchType: this.dispatchType,
      overviewId,
    };
    this.loading = true;
    await this.$store.dispatch("survey/fetchOverviewDetails", payload);
    this.loading = false;
  }

  get details() {
    let data;
    switch (this.dispatchType) {
      case "admission":
        data = this.$store.getters["survey/admissionOverviewDetails"];
        break;
      case "discharge":
        data = this.$store.getters["survey/dischargeOverviewDetails"];
        break;
      case "satisfaction":
        data = this.$store.getters["survey/satisfactionOverviewDetails"];
        break;
      default:
        data = null;
    }
    return data;
  }

  destroyed() {
    this.$store.dispatch("survey/clearSummaryDetails");
  }

  back() {
    this.$router.push({
      path: `/survey/overview`,
      query: {
        dispatchType: this.dispatchType,
      },
    });
  }

  complete(dispatchType: string) {
    this.$router.push({
      path: `/survey/overview`,
      query: {
        dispatchType: dispatchType,
      },
    });
  }

  formatDate(date: string): string {
    return moment(date).format("MM/DD/YYYY @ hh:mm");
  }
}
